<template>
  <div class="no-device">
      <div class="content">
        <icon-no-device v-if="showIcon"
                      class="icon"
                      height="70"
                      width="70"
                      iconColor="#8067B7" />
        {{ $t("noPrimaryDevice") }}
      </div>
    </div>
</template>

<script>
  export default {
    props: {
      showIcon: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .no-device {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    border: 1px solid #e5e5e5;
    border-radius: 8px;

    .content {
      font-size: 20px;
      font-weight: bold;
      line-height: 20px;
      color: map.get($colors, primary);

      display: flex;
      flex-direction: column;
      align-items: center;

      .icon {
        margin-bottom: 16px;
      }
    }
  }
</style>
